/* eslint-disable no-prototype-builtins */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { Instance, types } from "mobx-state-tree";
import i18next from "i18next";

import {
  AccountRiskType,
} from "@/apis/login/login.interface";
// 导入接口
import { 
  getMindData
} from "@/apis/login/login.api";
import { fetchSettingsConsent } from "@/apis/help/help.api";

import {
  
} from "@/app/login/type/index"

// 导入常量
import loginConfig from "@/constants/loginConfig";

// 导入utils类
import { 
  getCountryList,
  syncLoginState
} from "@/app/login/utils/index";
import cookieUtil from "@/utils/cookieUtils";
import { clearUrlExtraParams } from "@/utils/extUrlParamsUtils";
import { canOpenJoybuyRisk, openRiskControl } from "@/utils/login/riskControlUtil";
import { queryGlobalCountriesData } from "@/utils/countryUtils";
import { getMultiTargetDomain, isProduction, isBeta, userSwitchCountry, setTargetDomain } from "@/utils/multiSite/index";

import UKToast from "@/components/UKToast/index";

import {
  sendClickTrack as emailPasswordSendClickTrack,
  sendKeyActionTrack as emailPasswordSendKeyActionTrack,
  EXPOSURE_RECORD as EMAIL_PASSWORD_EXPOSURE_RECORD,
} from "@/tracks/25290";

const CountryDataType = types.model("CountryDataType", {
  code: types.string,
  country: types.string,
  lang: types.string, 
  name: types.string, 
  rule: types.string
});

const MindDataType = types.model("MindDataType", {
  icon: types.string,
  scope: types.maybe(types.number),
  seqNumber: types.maybe(types.number),
  serviceContent: types.maybe(types.string),
  serviceSubTitle: types.string,
  serviceTitle: types.string
});

const RiskInfoModel = types.model('RiskInfoModel', {
  title: types.optional(types.string, ''),
  reason: types.optional(types.string, '')
});

const LoginInfoModel = types.model('LoginInfoModel', {
  riskType: types.optional(types.number, AccountRiskType.Joybuy),
  userType: types.optional(types.string, ''),
  otpType: types.optional(types.number, 0),
  phoneOrEmail: types.optional(types.string, ''),
  identifier: types.optional(types.string, ''),
  idPrefix: types.optional(types.string, ''),
  scene: types.optional(types.number, 0),
  captchaAction: types.optional(types.string, ''),
  sessionId: types.optional(types.string, '')
});

export const LoginStoreModel = types
  .model("LoginStore")
  .props({
    countryList: types.optional(types.array(CountryDataType), []),
    pageFlag: types.optional(types.string, ''), // 该展示哪个页面
    pageStack: types.optional(types.array(types.string), []),

    loginInfo: types.optional(LoginInfoModel, {}),  // 输入手机号或者邮箱之后拿到的数据信息

    // 邮箱注册登录的验证码相关
    pwdForEmail: types.optional(types.string, ""), // 邮箱登录注册时候的密码

    oldParamsData: types.optional(LoginInfoModel, {}), // 老用户页面需要的数据
    mindData: types.optional(types.array(MindDataType), []),

    stepCode: types.optional(types.string, ""), // 步骤码，登录注册流程需要携带,后端使用

    // 当前国家信息
    currentCountryInfo: types.frozen(),
    // 登录注册使用的公共参数
    loginCommonParams: types.frozen(),

    // 滑块相关
    sliderFail: types.optional(types.boolean, false), // 滑块加载失败
    sliderLoading: types.optional(types.boolean, false), // 滑块是否加载中
    // 风控弹窗相关
    freezeAccount: types.optional(types.frozen({}), {}),
    accountSetOpen: types.optional(types.boolean, false),
    isFreeze: types.optional(types.boolean, false),
    riskOpen: types.optional(types.boolean, false),
    riskInfo: types.optional(RiskInfoModel, {
      title: '',
      reason: ''
    }),
  })
  .volatile(self => ({
    _tryAgainFunc: () => console.log("默认的tryAgainFunc")
  }))
  // 是vue的计算属性
  .views((self) => ({
    get isNew() {
      return self.loginInfo.userType === loginConfig.LOGIN.NEW_USER
    },
    get tryAgainFunc() {
      return self._tryAgainFunc;
    }
  }))
  .actions((self: any) => ({
    // 在模型实例创建后立即调用
    async afterCreate() {
      if (!!self.countryList.length) {
        return;
      }
      const { mobileLocations } = await getCountryList();
      self.setCountryList(mobileLocations);
    },

    setCountryList(data: any) {
      self.countryList = data;
    },

    // 设置当前该展示哪个页面了
    setPageFlag(data: string) {
      self.pageFlag = data;
      self.pageStack.push(data);
    },
    setPageStack(data: Array<string>) {
      self.pageStack = data;
    },

    // 输入手机号或者邮箱之后拿到的数据信息
    setLoginInfo(data: any) {
      self.loginInfo = data;
    },

    setTryAgainFunc(newFunc: any) {
      self._tryAgainFunc = newFunc;
    },
    setPwdForEmail(data: string) {
      self.pwdForEmail = data;
    },

    // 老用户页面需要的数据
    setOldParamsData(data: any) {
      self.oldParamsData = data;
    },

    setStepCode(data: string) {
      self.stepCode = data;
    },

    // 输入完手机号或者邮箱 || 老用户登录页面点下一步了，进入下一级页面的处理函数
    loginContinue(params: any) {
      self.setLoginInfo(params || {});
      params.phoneOrEmail === loginConfig.LOGIN.PHONE_LOGIN
      ? self.setPageFlag(loginConfig.LoginStateEnum.PHONE_LOGIN)
      : self.setPageFlag(loginConfig.LoginStateEnum.EMAIL_LOGIN_PASSWORD)
    },

    // 弹窗打开的话，打开就需要获取心智数据
    async setMindData() {
      const sessionMindList = cookieUtil.getSessionStorage(loginConfig.LOGIN.MIND_SESSION_STORAGE);
      if (sessionMindList) {
        console.log(JSON.parse(sessionMindList), "sessionMindList");
        const l = JSON.parse(sessionMindList)
        if (l && l.length > 1) {
          self.mindData = l;
        }
      } else {
        try {
          const res = await getMindData(loginConfig.MindScopeEnum.SIGN_IN_REGISTER);
          if (res && res.success) {
            if (res.data.length > 1) {
              cookieUtil.setSessionStorage(loginConfig.LOGIN.MIND_SESSION_STORAGE, JSON.stringify(res.data));
              self.mindData = res.data;
            }
          }
        } catch (error) {}
      }
    },

    setLoginCommonParams(data: any) {
      const { 
        countryCode,
        siteCode,
        language,
        currency
      } = data;
      self.loginCommonParams = {
        countryCode,
        siteCode,
        languageCode: language,
        currencyCode: currency
      };
    },
    async initCountryInfo() {
      const { currentCountry } = await queryGlobalCountriesData();
      currentCountry && self.handleCountryChange(currentCountry);
    },
    // 切换国家
    handleCountryChange(data: any) {
      const { countryCode } = data;
      self.currentCountryInfo = data;
      self.setLoginCommonParams(data);
      if (isProduction || isBeta) {
        // 目标domain和当前domain不一致，要执行跳转
        const {isSeemDomain, urlObject} = setTargetDomain(countryCode, "/login");
        if (!isSeemDomain) {
          window.location.href = urlObject.href;
        }
      }
    },
    /* ------------------------------------------------------------------------------- 手机号登录注册相关 ----------------------------------------------------------------------------------- */
    // 获取最新的returnUrl
    getReturnUrl() {
      const urlParams = new URLSearchParams(window.location.search);
      return urlParams.get("returnUrl") || "";
    },
    // 登录注册成功之后的统一处理
    async loginSuccessHandle(res?: any) {
      UKToast.show({
        icon: "success",
        content: res?.msg || i18next.t("login.signin.success"),
      });
      const { 
        countryCode = "", 
        currencyCode = "", 
        siteCode = "", 
        languageCode = "" 
      } = typeof res?.data === 'object' ? res.data : {};
      userSwitchCountry(self.currentCountryInfo?.countryCode || countryCode, false);
      // 登录成功后调用删除clearUrlExtraParams
      clearUrlExtraParams();
      // 关闭隐私协议变更通知弹窗
      await fetchSettingsConsent();
      syncLoginState(res?.data?.finalRedirectUrl || self.getReturnUrl());
    },
    // 手机号登录成功后的回调函数
    async phoneLoginSuccessHandle(res: any) {
      self.loginSuccessHandle(res);
      cookieUtil.setCookie(loginConfig.loginLocalInfo.USER_SUCCESS_ACCOUNT, self.loginInfo.idPrefix + "_" + self.loginInfo.identifier, 15, loginConfig.POSTFIX_DOMAIN);
    },
    // 邮箱登录成功后的回调函数
    async emailLoginSuccessHandle(res: any) {
      self.loginSuccessHandle(res);
      cookieUtil.setCookie(loginConfig.loginLocalInfo.USER_SUCCESS_ACCOUNT, self.loginInfo.identifier, 15, loginConfig.POSTFIX_DOMAIN);
      /** 关键事件上报-用户登录结果返回 */
      emailPasswordSendKeyActionTrack.EmailPassword_LoginResult({
        isNew: self.isNew ? "1" : "0",
        is_success: res?.success ? "1" : "0",
      });
    },
    /* ------------------------------------------------------------------------------- 弹窗统一返回，关闭处理 ----------------------------------------------------------------------------------- */
    // 弹窗内点击返回的处理,同点击编辑的处理
    returnDialog() {
      if (self.pageStack.length > 1) {
        self.pageStack.pop();
        self.pageFlag = self.pageStack[self.pageStack.length - 1];
      } else if (self.pageStack.length === 1) {
        // 如果只有一个元素，清空栈并重置 pageFlag
        self.pageStack = [];
        self.pageFlag = loginConfig.LoginStateEnum.LOGIN_DEFAULT;
      }
    },
    /* ------------------------------------------------------------------------------- 滑块相关 ----------------------------------------------------------------------------------- */
    sliderHandle() {
      // 滑块加载中
      const onSliderLoading = () => {
        self.setSliderFail(false);
        self.setSliderLoading(true);
      }
      // 滑块取消加载
      const onCancelLoading = () => {
        self.setSliderLoading(false);
      }
      // 滑块加载成功
      const onSliderSuccess = () => {
        self.setSliderFail(false);
        self.setSliderLoading(false);
      }
      // 滑块加载失败
      const onSliderFail = () => {
        self.setSliderFail(true);
        self.setSliderLoading(false);
      }
      // 滑块关闭
      const onSliderCancel = () => {
        self.setSliderLoading(false);
      };
      // 滑块加载成功
      const onSliderLoad = () => {
        self.setSliderFail(false);
        self.setSliderLoading(false);
      }
      return {
        onSliderLoading,
        onCancelLoading,
        onSliderSuccess,
        onSliderFail,
        onSliderCancel,
        onSliderLoad
      };
    },
    setSliderFail(data: boolean) {
      self.sliderFail = data;
    },
    setSliderLoading(data: boolean) {
      self.sliderLoading = data;
    },
    /* ------------------------------------------------------------------------------- 风控相关 ----------------------------------------------------------------------------------- */
    // 风控账户处理
    freezeAccountHandle(res: any) {
      // 账号被冻结 -- 15001 -- 打开冻结弹框
      if (res?.code === loginConfig.RiskEnum.CODE_FREEZE) {
        const data = res?.data;
        self.setFreezeAccount({
          reason: data?.reason, // 冻结原因
          email: data?.customerEmail, // 手机或邮箱
          mobile: data?.customerMobile, // 手机或邮箱
          otpType: data?.otpType, // 类型 3: 邮箱
        });
        self.setIsFreeze(true);
        return true;
      }

      // 账号被风控 -- 15000 -- 打开绑定 账号弹框
      if (res?.code === loginConfig.RiskEnum.CODE_RISK) {
        const data = res?.data;
        self.setFreezeAccount({
          scene: data?.scene, // 风控场景
          reason: data?.reason, // 冻结原因
          otpType: data?.otpType, // 类型 2: 手机号
          idPrefix: data?.idPrefix, // 手机号国家
          identifier: data?.identifier, // 手机或邮箱
          previousStepCode: data?.previousStepCode,
          isRiskControlAccount: true,
        });
        self.setAccountSetOpen(true);
        return true;
      }

      // 风控禁止注册
      if (res?.code === loginConfig.RiskEnum.CODE_FORBIDDEN_REGISTER) {
        const data = res?.data;
        self.setRiskInfo({
          title: data?.title || '', // 标题
          reason: data?.reason || '', // 原因
        });
        self.setRiskOpen(true);
        return true;
      }

      // 打开滑块风控
      if (res?.code && canOpenJoybuyRisk(parseInt(res.code))) {
        console.log('self.tryAgainFunc=', self.tryAgainFunc);
        self.tryAgainFunc && self.tryAgainFunc();
        return true;
      }
      return false;
    },
    setIsFreeze(data: boolean) {
      self.isFreeze = data;
    },
    setAccountSetOpen(data: boolean) {
      self.accountSetOpen = data;
    },
    setFreezeAccount(data: any) {
      self.freezeAccount = data;
    },
    setRiskOpen(data: boolean) {
      self.riskOpen = data;
    },
    setRiskInfo(data: any) {
      self.riskInfo = data;
    },
    /* ------------------------------------------------------------------------------- 三方登录相关 ----------------------------------------------------------------------------------- */
    
  }));

export interface LoginStoreModel extends Instance<typeof LoginStoreModel> {}